import React, { useState } from 'react';

interface LayoutProps {
  children: React.ReactNode;
  showDemo?: boolean;
  isAdmin?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showDemo = false, isAdmin = false }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="layout-container">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav-brand">
            <a href="/" style={{ textDecoration: 'none' }}>
              <h1 className="logo" style={{ fontFamily: 'Georgia, serif', color: '#000042' }}>Meistro Asistentas</h1>
              <p className="tagline" style={{ color: '#666' }}>Jūsų AI asistentas</p>
            </a>
          </div>
          {!isAdmin && (
            <>
              {/* Mobile Menu Button - Mobile Only */}
              {window.innerWidth < 768 && (
                <button
                  onClick={toggleMobileMenu}
                  style={{
                    position: 'fixed',
                    top: '1rem',
                    right: '1rem',
                    zIndex: 1001,
                    background: '#000042',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '0.75rem',
                    cursor: 'pointer',
                    fontSize: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '48px',
                    height: '48px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {isMobileMenuOpen ? '✕' : '☰'}
                </button>
              )}

              {/* Mobile Menu Overlay */}
              {isMobileMenuOpen && window.innerWidth < 768 && (
                <div
                  onClick={toggleMobileMenu}
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 999
                  }}
                />
              )}

              {/* Navigation */}
              <nav style={{
                position: window.innerWidth < 768 ? 'fixed' : 'static',
                top: 0,
                left: 0,
                right: 0,
                width: window.innerWidth < 768 ? '100vw' : 'auto',
                height: window.innerWidth < 768 ? '100vh' : 'auto',
                backgroundColor: window.innerWidth < 768 ? '#ffffff' : 'transparent',
                zIndex: 1000,
                transform: window.innerWidth < 768
                  ? (isMobileMenuOpen ? 'translateY(0)' : 'translateY(-100%)')
                  : 'none',
                transition: 'transform 0.3s ease',
                display: 'flex',
                flexDirection: window.innerWidth < 768 ? 'column' : 'row',
                alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
                padding: window.innerWidth < 768 ? '5rem 2rem 2rem' : '0',
                overflowY: window.innerWidth < 768 ? 'auto' : 'visible'
              }}>
                <ul style={{
                  listStyle: 'none',
                  margin: 0,
                  padding: 0,
                  display: 'flex',
                  flexDirection: window.innerWidth < 768 ? 'column' : 'row',
                  gap: window.innerWidth < 768 ? '1rem' : '1.5rem',
                  alignItems: window.innerWidth < 768 ? 'stretch' : 'center'
                }}>
                  <li>
                    <a
                      href="/kainos"
                      onClick={() => window.innerWidth < 768 && setIsMobileMenuOpen(false)}
                      style={{
                        display: 'block',
                        padding: window.innerWidth < 768 ? '1rem' : '0',
                        color: '#000042',
                        textDecoration: 'none',
                        fontSize: window.innerWidth < 768 ? '1.1rem' : '1rem',
                        fontWeight: window.innerWidth < 768 ? '500' : 'normal',
                        borderRadius: window.innerWidth < 768 ? '8px' : '0',
                        backgroundColor: window.innerWidth < 768 ? '#f8f9fa' : 'transparent'
                      }}
                    >
                      Kainos
                    </a>
                  </li>
                  <li>
                    <a
                      href="/pagalba"
                      onClick={() => window.innerWidth < 768 && setIsMobileMenuOpen(false)}
                      style={{
                        display: 'block',
                        padding: window.innerWidth < 768 ? '1rem' : '0',
                        color: '#000042',
                        textDecoration: 'none',
                        fontSize: window.innerWidth < 768 ? '1.1rem' : '1rem',
                        fontWeight: window.innerWidth < 768 ? '500' : 'normal',
                        borderRadius: window.innerWidth < 768 ? '8px' : '0',
                        backgroundColor: window.innerWidth < 768 ? '#f8f9fa' : 'transparent'
                      }}
                    >
                      Pagalba
                    </a>
                  </li>
                  <li>
                    <a
                      href="/kontaktai"
                      onClick={() => window.innerWidth < 768 && setIsMobileMenuOpen(false)}
                      style={{
                        display: 'block',
                        padding: window.innerWidth < 768 ? '1rem' : '0',
                        color: '#000042',
                        textDecoration: 'none',
                        fontSize: window.innerWidth < 768 ? '1.1rem' : '1rem',
                        fontWeight: window.innerWidth < 768 ? '500' : 'normal',
                        borderRadius: window.innerWidth < 768 ? '8px' : '0',
                        backgroundColor: window.innerWidth < 768 ? '#f8f9fa' : 'transparent'
                      }}
                    >
                      Kontaktai
                    </a>
                  </li>
                  <li>
                    <a
                      href="/registracija"
                      onClick={() => window.innerWidth < 768 && setIsMobileMenuOpen(false)}
                      className="btn-secondary"
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        padding: window.innerWidth < 768 ? '1rem' : undefined
                      }}
                    >
                      Registruotis
                    </a>
                  </li>
                  <li>
                    <a
                      href="/prisijungti"
                      onClick={() => window.innerWidth < 768 && setIsMobileMenuOpen(false)}
                      className="btn-primary"
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        padding: window.innerWidth < 768 ? '1rem' : undefined
                      }}
                    >
                      Prisijungti
                    </a>
                  </li>
                </ul>
              </nav>
            </>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="layout-main">
        <div className="container">
          <div className={`content-wrapper ${showDemo ? 'with-demo' : ''}`}>
            <div className="main-content">
              {children}
            </div>

            {showDemo && (
              <div className="demo-sidebar">
                <div className="card">
                  <h4 style={{ fontFamily: 'Georgia, serif', color: '#000042', marginBottom: '1rem' }}>🎧 AI Pokalbio Pavyzdys</h4>

                  {/* Audio Player - Placeholder for voice file */}
                  <div style={{
                    background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    marginBottom: '1rem'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                      marginBottom: '1rem'
                    }}>
                      <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                      }}>
                        🎙️
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 'bold', color: '#000042' }}>Tikras pokalbis su AI</div>
                        <div style={{ fontSize: '0.85rem', color: '#666' }}>Klientas užklausia apie dažymo paslaugas</div>
                      </div>
                    </div>

                    {/* Audio element - will be replaced with actual file */}
                    <audio
                      controls
                      style={{
                        width: '100%',
                        borderRadius: '8px',
                        outline: 'none'
                      }}
                      preload="metadata"
                    >
                      <source src="/audio/demo-call.mp3" type="audio/mpeg" />
                      <source src="/audio/demo-call.ogg" type="audio/ogg" />
                      Jūsų naršyklė nepalaiko garso grotuvo.
                    </audio>

                    <div style={{
                      marginTop: '1rem',
                      padding: '0.75rem',
                      background: 'rgba(255, 255, 255, 0.7)',
                      borderRadius: '8px',
                      fontSize: '0.85rem',
                      color: '#555'
                    }}>
                      <strong>Pokalbio santrauka:</strong>
                      <ul style={{ margin: '0.5rem 0 0 1rem', padding: 0 }}>
                        <li>AI pasveikina klientą ir prisistatė</li>
                        <li>Klientas klausia apie vonios dažymo kainą</li>
                        <li>AI užduoda tikslinančius klausimus apie plotą</li>
                      </ul>
                    </div>
                  </div>

                  <div className="demo-info">
                    <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: '1.5' }}>
                      <strong>Taip AI asistentas bendrauja telefonu su jūsų klientais 24/7</strong>
                      <br />
                      <small>Natūralus balso pokalbis, automatinė informacijos fiksacija ir ataskaitos</small>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h4>Meistro Asistentas</h4>
              <p>
                Profesionalus AI balso asistentas Lietuvos paslaugų teikėjams.
                Automatizuokite skambučius, taupykite laiką, didinkite pardavimus.
              </p>
            </div>

            <div className="footer-section">
              <h5>Paslaugos</h5>
              <ul>
                <li><a href="/#paslaugos">Visos paslaugos</a></li>
                <li><a href="/#dazytojai">Dažytojams</a></li>
                <li><a href="/#elektrikai">Elektrikams</a></li>
                <li><a href="/#santechnikai">Santechnikams</a></li>
                <li><a href="/#staliai">Staliams</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h5>Įmonė</h5>
              <ul>
                <li><a href="/">Pradžia</a></li>
                <li><a href="/kainos">Kainos</a></li>
                <li><a href="/kontaktai">Kontaktai</a></li>
                <li><a href="/registracija">Registracija</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h5>Pagalba</h5>
              <ul>
                <li><a href="/pagalba">DUK</a></li>
                <li><a href="/prisijungti">Prisijungti</a></li>
                <li><a href="/reset-password">Atkurti slaptažodį</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h5>Teisinė informacija</h5>
              <ul>
                <li><a href="https://atsiliepsiu.lt/privatumo-politika">Privatumo politika</a></li>
                <li><a href="https://atsiliepsiu.lt/naudojimosi-salygos">Naudojimo sąlygos</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Ainora, MB. Visos teisės saugomos.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;